import { useState, useEffect, useCallback } from "react";
import { api } from "../services/api/api";

interface OdooPricingRange {
    min: number;
    max: number | null;
    factor: number;
}

export interface OdooConfig {
    pricingCounterRanges: OdooPricingRange[];
    easytechUrl?: string;
    odooHost?: string;
}

export function useOdooConfig() {
    const [config, setConfig] = useState<OdooConfig | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                setLoading(true);
                const res = await api.get("admin/odoo/config");
                console.log("Odoo Config fetched:", res);
                if (res) {
                    setConfig(res as OdooConfig);
                }
            } catch (error) {
                console.error("Error fetching Odoo config", error);
                // Silent fail or toast? Silent is better for config load
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []);

    const computeSellingPrice = useCallback((cost: number): number => {
        if (!config?.pricingCounterRanges) {
            console.warn("Odoo Config missing or incomplete:", config);
            return cost;
        }

        const ranges = config.pricingCounterRanges;

        // Logic matched from Java PartFactory
        for (const range of ranges) {
            const min = range.min;
            const max = range.max;

            const gteMin = (min === null || min === undefined) || cost >= min;
            const ltMax = (max === null || max === undefined) || cost < max;

            if (gteMin && ltMax) {
                console.log("Matching range found:", range, "Factor applied:", range.factor, "Selling Price:", cost * range.factor);
                return cost * range.factor;
            }
        }

        return cost;
    }, [config]);

    return {
        config,
        loading,
        computeSellingPrice
    };
}
